import { render, staticRenderFns } from "./user-widget.vue?vue&type=template&id=2d740218&scoped=true"
import script from "./user-widget.vue?vue&type=script&lang=js"
export * from "./user-widget.vue?vue&type=script&lang=js"
import style0 from "./user-widget.vue?vue&type=style&index=0&id=2d740218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d740218",
  null
  
)

export default component.exports